import { forwardRef, Ref } from "react";
import {
  ListItemIcon,
  ListItemText,
  MenuItemProps,
  MenuItem as MuiMenuItem,
} from "@material-ui/core";
import { useStyles } from "./styles";

export interface IMenuItemProps extends MenuItemProps {
  icon?: React.ReactNode;
  text?: string;
}

const MenuItem = forwardRef(
  (props: IMenuItemProps, ref?: Ref<HTMLLIElement>) => {
    const { icon, text, children, ...rest } = props;
    const classes = useStyles();

    return (
      <MuiMenuItem
        className={classes.menuItem}
        disableGutters
        ref={ref}
        {...rest}
        button
      >
        {icon && <ListItemIcon>{icon}</ListItemIcon>}
        {text && <ListItemText color="textPrimary" primary={text} />}
        {children}
      </MuiMenuItem>
    );
  },
);

export default MenuItem;
